export default "__VITE_ASSET__DZAHISSH__"